import React, { use, useEffect } from "react";
import { ChevronLeft, Mail, FileText, RefreshCw } from "lucide-react";
import { useAtom } from "jotai";
import { activeChildDetail, CertificateURL, pass } from "../../../atomstore/store";
import { sendFeeCertificate } from "../../../queryfunctions/queryfunctions";
import { useRequestProcessor } from "../../../requestProcessor";
import SpinnerLoading from "../../common/SpinnerLoading";
import { useNavigate } from "react-router-dom";

const ShareFeeCertificate = () => {
    const navigate = useNavigate();
    const [certificateUrl] = useAtom(CertificateURL);
    const [activeChild] = useAtom(activeChildDetail);
    const [selectedChild] = useAtom(pass)

    const { useMutationWrapper } = useRequestProcessor();

    useEffect(() => {
        console.log("[Share Certificate] Screen Loaded:", selectedChild?.id);
    }, [selectedChild]);

    const Sharecertificate = useMutationWrapper(
        "Sharecertificate",
        () => {
            return sendFeeCertificate(certificateUrl, selectedChild);
        },
        {
            onSuccess: (data) => {
                navigate('/home')
                console.log("[Share Certificate] Success:", data);
            },
        }
    );

    return (
        <div className="fixed inset-0 bg-gray-50 z-50 overflow-y-auto">
            {Sharecertificate.isLoading && <SpinnerLoading />}

            {/* Header */}
            <div className="sticky top-0 bg-white border-b p-4 flex items-center space-x-3">
                <button onClick={() => navigate(-1)}>
                    <ChevronLeft className="w-6 h-6 text-gray-600" />
                </button>
                <h2 className="text-lg font-bold text-gray-800 cursor-pointer" onClick={() => navigate(-1)}>Fee Certificate</h2>
            </div>

            {/* Content */}
            <div className="p-4 space-y-4">
                {/* Info Banner */}
                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-lg">
                    <p className="text-sm text-blue-800">
                        Choose an action for{" "}
                        <span className="font-semibold">{selectedChild?.name} {selectedChild?.last_name}</span>'s
                        fee certificate.
                    </p>
                </div>

                {/* Option 1 - Send to Mail */}
                <button
                    onClick={() => Sharecertificate.mutate()}
                    className="w-full bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex items-center space-x-4 active:scale-95 transition"
                >
                    <Mail className="w-10 h-10 text-red-500" />

                    <div className="flex flex-col text-left">
                        <p className="font-semibold text-gray-800">Send to Mail</p>
                        <p className="text-sm text-gray-500">
                            Sends the certificate to your registered email.
                        </p>
                    </div>
                </button>

                {/* Option 2 - View Certificate */}
                <a
                    href={certificateUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="w-full bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex items-center space-x-4 active:scale-95 transition"
                >
                    <FileText className="w-10 h-10 text-yellow-500" />

                    <div className="flex flex-col text-left">
                        <p className="font-semibold text-gray-800">View Certificate</p>
                        <p className="text-sm text-gray-500">
                            Opens the certificate in a new tab.
                        </p>
                    </div>
                </a>

                {/* Option 3 - Regenerate */}
                <button
                    onClick={() => navigate('/fee')}
                    className="w-full bg-white rounded-2xl p-4 shadow-sm border border-gray-100 flex items-center space-x-4 active:scale-95 transition"
                >
                    <RefreshCw className="w-10 h-10 text-gray-700" />

                    <div className="flex flex-col text-left">
                        <p className="font-semibold text-gray-800">
                            Regenerate Certificate
                        </p>
                        <p className="text-sm text-gray-500">
                            Create a fresh copy of the certificate.
                        </p>
                    </div>
                </button>
            </div>
        </div>
    );
};

export default ShareFeeCertificate;
